
import './App.css';
import Sidebar from './Components/Sidebar'




function App() {



  return (
    <>


    <div className="container">
      <Sidebar/>
    </div>



    </>
  );
}

export default App;
